/* eslint-disable react-hooks/exhaustive-deps */
/* we want to run this hook only on the first display of the page */
/* or when the place has changed */
import { useEffect } from 'react';
import { useThorView } from '@aviv-dxp/react-thor';
import { useTrackingProps } from '@/hooks/useTrackingProps/useTrackingProps';
import { usePageLayoutContext } from '../usePageLayoutContext/usePageLayoutContext';
export const useThorPageView = (pageTitleError) => {
    const { isLoading } = usePageLayoutContext();
    const viewProps = useTrackingProps(pageTitleError);
    const view = useThorView();
    useEffect(() => {
        if (viewProps && !isLoading) {
            view({ viewProps });
        }
    }, [isLoading]);
};
